export const uploadV2Media = async (blob: Blob, uploadUrl?: string) => {
  if (!uploadUrl) {
    console.warn('No upload URL returned')
    return
  }

  await fetch(uploadUrl, {
    method: 'PUT',
    headers: {
      'Content-Type': blob.type
    },
    body: blob
  })
}
